module.exports = __webpack_public_path__ + "static/media/uw_madison.d375e59f.jpg";